import React, { useState, useEffect } from "react";
import { Input, Modal, ModalBody } from "@windmill/react-ui";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";

const TripadvancePaymentModal = ({
  isOpen,
  onClose,
  title,
  handleSubmit,
  tripAdvanceAmt,
  finalAmt,
  data,
}) => {
  const [utr, setUtr] = useState("");
  const [error, setError] = useState("");
  const [remark, setRemark] = useState("");
  const [searchstartDate, setSearchStartDate] = useState(new Date());
  const [paymentType, setPaymentType] = useState(null);
  // Tracks how much of each checked debt is actually being used (id -> contributed
  // amount) — capped at what's still needed, not the debt's full outstanding amount,
  // e.g. a ₹3000 debt against a ₹500 remaining need only contributes ₹500 here,
  // leaving ₹2500 of that debt untouched for future use (matches backend behavior).
  const [selectedContributions, setSelectedContributions] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [remainingAmount, setRemainingAmount] = useState(tripAdvanceAmt);
  const [isAutoAdjusted, setIsAutoAdjusted] = useState(false);
  // console.log(finalAmt)
  useEffect(() => {
    setRemainingAmount(tripAdvanceAmt);
    // console.log(tripAdvanceAmt,finalAmt)
  }, [tripAdvanceAmt]);
  useEffect(() => {
    if (isOpen) {
      setSelectedContributions({});
      setSelectedIds([]);
      setTotalAmount(0);
      setRemainingAmount(tripAdvanceAmt);
      setPaymentType(null);
      setSearchStartDate(new Date());
      setRemark("");
      setUtr("");
      setError("");
      setIsAutoAdjusted(false); // add this
    }
  }, [isOpen, tripAdvanceAmt]);
  const onSubmit = () => {
    // let errorMsg = "";

    // // Existing validations
    // if (!searchstartDate) {
    //   errorMsg = "Payment Date is required.";
    // } else if (!paymentType) {
    //   errorMsg = "Payment Type is required.";
    // } else if (paymentType === "Bank Transaction" && !utr) {
    //   errorMsg = "UTR Number is required for Bank Transaction.";
    // } else if (paymentType !== "Bank Transaction" && !remark.trim()) {
    //   errorMsg = "Remark is required for this payment type.";
    // }

    // // New validation for remainingAmount
    // else if (remainingAmount === "" || Number(remainingAmount) <= 0) {
    //   errorMsg = "Payable Amount must be greater than 0.";
    // }

    // if (errorMsg) {
    //   setError(errorMsg);
    //   return;
    // }

    // setError("");

    let errorMsg = "";
    if (!searchstartDate) {
      errorMsg = "Payment Date is required.";
    } else if (remainingAmount === "") {
      errorMsg = "Please enter a payable amount.";
    } else if (!isAutoAdjusted && Number(remainingAmount) <= 0) {
      errorMsg = "Please enter a payable amount greater than 0.";
    } else if (!isAutoAdjusted && !paymentType) {
      errorMsg = "Payment Type is required.";
    } else if (paymentType === "Bank Transaction" && !utr.trim()) {
      errorMsg = "UTR Number is required.";
    } else if (paymentType === "Cash" && !remark.trim()) {
      errorMsg = "Remark is required.";
    }

    if (errorMsg) {
      setError(errorMsg);
      return;
    }

    setError("");
    const updatedData = {
      paid_date: searchstartDate,
      payment_type: paymentType,
      utr: paymentType === "Bank Transaction" ? utr : "",
      remark: remark,
      trip_advance_request: tripAdvanceAmt,
      payable_amount: remainingAmount,
      adjusted_amount: totalAmount,
      va_ids: selectedIds,
    };

    handleSubmit(updatedData);
    onClose();
  };

  // Update the handler to accept the id parameter as well.

  //  const handleCheckboxChange = (amount, id, isChecked) => {
  //     const numericAmount = parseFloat(amount) || 0;

  //     if (isChecked) {
  //       const newTotal = totalAmount + numericAmount;
  //       setTotalAmount(newTotal);
  //       let payable_amount = tripAdvanceAmt - newTotal;
  //       setRemainingAmount(payable_amount < 0 ? 0 : payable_amount);
  //       setSelectedAmounts((prev) => [...prev, numericAmount]);
  //       setSelectedIds((prev) => [...prev, id]);
  //     } else {
  //       const newTotal = totalAmount - numericAmount;
  //       setTotalAmount(newTotal);
  //       let payable_amount = tripAdvanceAmt - newTotal;
  //       setRemainingAmount(payable_amount < 0 ? 0 : payable_amount);
  //       setSelectedAmounts((prev) => prev.filter((a) => a !== numericAmount));
  //       setSelectedIds((prev) => prev.filter((selectedId) => selectedId !== id));
  //     }
  //   };

  const handleCheckboxChange = (amount, id, isChecked) => {
    const numericAmount = Number(amount) || 0;

    let newTotal;
    let newSelectedIds;
    const newContributions = { ...selectedContributions };

    if (isChecked) {
      const remainingBefore = Math.max(0, Number(tripAdvanceAmt) - totalAmount);
      const contributed = Math.min(numericAmount, remainingBefore);
      newContributions[id] = contributed;
      newTotal = totalAmount + contributed;
      newSelectedIds = [...selectedIds, id];
    } else {
      const contributed = newContributions[id] || 0;
      delete newContributions[id];
      newTotal = totalAmount - contributed;
      newSelectedIds = selectedIds.filter((selectedId) => selectedId !== id);
    }

    setTotalAmount(newTotal);
    setSelectedContributions(newContributions);
    setSelectedIds(newSelectedIds);

    const payableAmount = Number(tripAdvanceAmt) - newTotal;

    if (payableAmount > 0) {
      setRemainingAmount(payableAmount);
      setIsAutoAdjusted(false);
    } else {
      // fully adjusted
      setRemainingAmount(0);
      setIsAutoAdjusted(true);

      setPaymentType(null);
      setRemark("");
      setUtr("");
    }

    setError("");
  };

  //   useEffect(() => {
  //     if (totalAmount > 0) {
  //       setPaymentType("Adjusted");
  //     }
  //   }, [totalAmount]);

  const isSelectionDisabled = totalAmount >= tripAdvanceAmt;
  const maxRemainingAmount = tripAdvanceAmt;
  return (
    <Modal
      className="relative bg-white p-5 dark:bg-gray-700 dark:text-white rounded-lg"
      style={{
        width: "500px",
        height: "auto",
        maxHeight: "80vh",
        overflowY: "auto",
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalBody className="custom-modal" style={{ margin: "0" }}>
        <h2 className="text-center font-bold text-lg">{title}</h2>
        {data && data.length > 0 ? (
          <div className="overflow-x-auto mt-4">
            <table className="table-auto w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-gray-300 px-4 py-2">Choose</th>
                  {/* <th className="border border-gray-300 px-4 py-2">
                    Start Date
                  </th> */}
                  <th className="border border-gray-300 px-4 py-2">
                    Reference No
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Outstanding Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-100">
                    <td className="border border-gray-300 px-4 py-2">
                      <input
                        type="checkbox"
                        autoComplete="off"
                        onChange={(e) =>
                          handleCheckboxChange(
                            item.outstanding_amount,
                            item.id,
                            e.target.checked,
                          )
                        }
                        disabled={
                          isSelectionDisabled && !selectedIds.includes(item.id)
                        }
                      />
                    </td>

                    {/* <td className="border border-gray-300 px-4 py-2 ">
                      {item.va_start_date
                        ? new Date(item.va_start_date).toLocaleDateString()
                        : "N/A"}
                    </td> */}

                    <td className="border border-gray-300 px-4 py-2">
                      {item.ref_no || "N/A"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item.outstanding_amount || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-gray-500 mt-4"></p>
        )}
        {isSelectionDisabled && (
          <p className="text-green-600 mt-4">
            Fully covered by adjustment — ready to save. Uncheck items to use
            less.
          </p>
        )}
        <div className="mt-4 flex space-x-4">
          {/* Bill Amount Input Box */}
          <div className="flex-1">
            <label htmlFor="billAmount" className="block text-gray-700">
              Approved Amount:
            </label>
            <input
              id="billAmount"
              type="text"
              value={finalAmt}
              readOnly
              className="input w-full border border-gray-300 rounded-md p-2 mt-2"
            />
          </div>

          {data && data.length > 0 && (
            <div className="flex-1">
              <label htmlFor="totalAmount" className="block text-gray-700">
                Adjustable Amount:
              </label>
              <input
                id="totalAmount"
                type="text"
                value={Math.abs(totalAmount)}
                readOnly
                className="input w-full border border-gray-300 rounded-md p-2 mt-2"
              />
            </div>
          )}

          {/* Remaining Amount Input Box */}
          <div className="flex-1">
            <label htmlFor="remainingAmount" className="block text-gray-700">
              Payable Amount:
            </label>
            {/* <input
              id="remainingAmount"
              type="number"
              value={remainingAmount}
              onChange={(e) => {
                let val = e.target.value;

                if (val === "") {
                  // User cleared input, set to empty string (no 0 default)
                  setRemainingAmount("");
                  // Clear error when user clears input so they can re-enter
                  setError("");
                  return;
                }

                // Convert to number and clamp
                let numVal = Number(val);
                if (isNaN(numVal) || numVal < 0) {
                  numVal = 0;
                } else if (numVal > maxRemainingAmount) {
                  numVal = maxRemainingAmount;
                }

                setRemainingAmount(numVal);

                // Clear error if amount is valid and > 0
                if (numVal > 0) {
                  setError("");
                }
              }}
              className="input w-full border border-gray-300 rounded-md p-2 mt-2"
              max={maxRemainingAmount}
              min={0}
            /> */}

            <input
              id="remainingAmount"
              type="number"
              value={remainingAmount}
              readOnly={isAutoAdjusted}
              onChange={(e) => {
                if (isAutoAdjusted) return;

                const value = e.target.value;

                if (value === "") {
                  setRemainingAmount("");
                  setError("");
                  return;
                }

                let numVal = Number(value);

                if (isNaN(numVal) || numVal < 0) {
                  numVal = 0;
                } else if (numVal > Number(tripAdvanceAmt) - totalAmount) {
                  numVal = Number(tripAdvanceAmt) - totalAmount;
                }

                setRemainingAmount(numVal);
                setIsAutoAdjusted(false);
                setError("");
              }}
              className={
                `input w-full border border-gray-300 rounded-md p-2 mt-2`
                // 	 ${
                //     isAutoAdjusted ? "bg-gray-100 cursor-not-allowed" : ""
                //   }
                //   `
              }
            />
          </div>
        </div>
        <div
          className="max-h-96 flex flex-col gap-5 mt-4"
          style={{ maxHeight: "60vh", scrollbarWidth: "thin" }}
        >
          <div className="flex flex-col flex-1">
            <LabelArea label="Payment Date" />
            <div className="w-100">
              <InputSearchDate
                value={searchstartDate}
                onChange={(event) => setSearchStartDate(event)}
              />
            </div>
          </div>

          {/* <div className="flex flex-col flex-1">
            <LabelArea label="Payment Type" />
            <select
              className="bg-white border border-gray-200 h-10 text-sm block w-full  focus:bg-white focus:border-gray focus:ring-1 focus:ring-blue-500 rounded"
              name="payment_type"
              onChange={(e) => setPaymentType(e.target.value)}
            >
              {totalAmount <= 0 && <option value="">Choose</option>}
              {totalAmount <= 0 && (
                <option value="Bank Transaction">Bank Transaction</option>
              )}
              {totalAmount <= 0 && <option value="Cash">Cash</option>} */}
          {/* {data && data.length > 0 && (
                <option value="Adjusted">Adjusted</option>
              )} */}
          {/* </select>
          </div> */}

          {Number(remainingAmount) > 0 && (
            <div className="flex flex-col flex-1">
              <LabelArea label="Payment Type" />
              <select
                className="bg-white border border-gray-200 h-10 text-sm block w-full rounded"
                value={paymentType || ""}
                onChange={(e) => setPaymentType(e.target.value)}
              >
                <option value="">Choose</option>
                <option value="Bank Transaction">Bank Transaction</option>
                <option value="Cash">Cash</option>
              </select>
            </div>
          )}

          {paymentType === "Bank Transaction" && (
            <Input
              className={`border h-10 text-sm block w-full ${
                error && paymentType === "Bank Transaction" && !utr
                  ? "border-red-500"
                  : ""
              }  focus:bg-white`}
              type="text"
              name="utr"
              placeholder="Enter UTR Number"
              value={utr}
              onChange={(e) => setUtr(e.target.value)}
            />
          )}

          {paymentType && paymentType !== "Bank Transaction" && (
            <div className="flex flex-col flex-1">
              <LabelArea label="Remark" />
              <Input
                className={`border h-10 text-sm block w-full ${
                  error && paymentType !== "Bank Transaction" && !remark
                    ? "border-red-500"
                    : ""
                } focus:bg-white`}
                type="text"
                name="remark"
                placeholder="Enter remark"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>
          )}

          {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
          <div className="flex justify-around mt-3">
            <button
              onClick={onClose}
              className="btn btn-secondary px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
            >
              Cancel
            </button>
            <button
              onClick={onSubmit}
              className="btn btn-primary px-4 py-2 bg-green-500 text-white rounded-md"
            >
              Save
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TripadvancePaymentModal;
